import React from "react";
import translate from "../../../config/translations/translate";
import "./styles.css";
import { MDBProgress, MDBIcon } from "mdbreact";

const LoadingPage = ({ t, progress }) => {

  return (
    <div className="gbp-container loading-page-container">
      <div className="loading-page-container">
        <div className="loading-page-header">
          <h1
            style={{
              fontFamily: "Open Sans",
              fontWeight: "bold",
              fontSize: "48px",
              color: "black",
            }}
          >
            {t("title")}
          </h1>
          <h4
            style={{
              fontFamily: "Open Sans",
              fontWeight: "normal",
              fontSize: "18px",
              color: "black",
            }}
          >
            {t("subtitle")}
          </h4>
        </div>
        <div className="w-100 d-flex justify-content-center">
          {/* <Spinner/> */}
          <MDBProgress

            value={progress}
            min={0}
            max={100}
            className="w-50 progress-bar-container"
            animated={true}
            preloader={true}
			barClassName="color-progress-bar"
          >
            <span className="p-1 font-bold">{progress}%</span>
          </MDBProgress>
        </div>
        <div
          style={{
            maxWidth: 720,
            margin: "10px auto 0",
            padding: 14,
            border: "1px solid #e5e7eb",
            background: "linear-gradient(180deg, #FAFBFF 0%, #F9FAFB 100%)",
            borderRadius: 10,
            boxShadow: "0 1px 2px rgba(16, 24, 40, 0.06)",
          }}
        >
          <div style={{ display: "flex", alignItems: "flex-start", gap: 12, justifyContent: "center" }}>
            <div aria-hidden="true" style={{ marginTop: 2, color: "#4F46E5" }}>
              <MDBIcon icon="spinner" spin size="lg" />
            </div>
            <div style={{ textAlign: "left" }}>
              <div style={{ fontWeight: 700, color: "#111827", marginBottom: 4 }}>
                {t("backgroundInfoTitle")}
              </div>
              <div style={{ color: "#4b5563", lineHeight: 1.5 }}>
                {t("backgroundInfoText")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

LoadingPage.translations = {
  title: {
    en: "Analyzing...",
    es: "Analizando...",
  },
  subtitle: {
    en: "We are analyzing all your stores to help you improve your positioning!",
    es: "Estamos analizando todos tus locales para ayudarte a mejorar tu posicionamiento!",
  },
  backgroundInfoTitle: {
    en: "We’re running your audit in the background",
    es: "Estamos ejecutando tu auditoría en segundo plano",
  },
  backgroundInfoText: {
    en: "You can leave this screen and come back later. We’ll keep working and save the results.",
    es: "Podés abandonar esta pantalla y volver más tarde. Seguiremos trabajando y guardaremos los resultados.",
  },
};

export const LoadingPageContainer = translate(
  LoadingPage
);
